import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const CardContent = styled('div')(
  ({ theme }) => `
  display: flex;
  align-items: center;
  text-align: left;
  gap: ${theme.DS_spacing(['xxs'])};

  > div:first-of-type {
    flex: 1 1 calc(100% - 32px);
    ${theme.breakpoints.up('lg')} {
       align-self: flex-start;
    }

  }
  > div:last-of-type {
    flex: 1 1 32px;
    display: flex;
    justify-content:center;
    svg{
    margin: 0 auto;
    }
  }
`,
);

// const dynamicHeadingStyles = ({ isActive, theme }) =>
//   isActive &&
//   `
//     color: ${theme.colors.accent};
//   `;

export const Heading = styled(Typography)(
  ({ theme }) => `
   margin: ${theme.DS_spacing(['xxs'])} 0;
`,
);

// export const dynamicDetailsStyles = ({ isDistance }) =>
//   isDistance &&
//   `
//     margin-right: 8px;
//     display: inline-block;
//   `;

export const Details = styled(Typography)(
  ({ theme }) => `
   color: ${theme.DS_palette.text.secondary};
`,
);

export const FreeParkingLabel = styled('span')``;
